var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuraasaColoredSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.36,
    height: 42.157,
    viewBox: "0 0 53.36 42.157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#ea8e25}.prefix__cls-2{fill:#886ea3}.prefix__cls-3{fill:#2fa6be}.prefix__cls-4{fill:#80b741}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon_ColorOnWhite_TGL",
    transform: "translate(-17.793 -23.392)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1",
    d: "M288.068 378.937l8.453 21.134a.172.172 0 0 0 .309.022l7.67-13.293a.172.172 0 0 0-.073-.243l-16.127-7.844a.172.172 0 0 0-.235.224z",
    className: "prefix__cls-1",
    "data-name": "Path 1",
    transform: "translate(-270.26 -355.303)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2",
    d: "M447.69 524.69l-8.018 13.18a.172.172 0 0 0 .185.256l12.413-2.911a.172.172 0 0 0 .119-.235L448 524.711a.172.172 0 0 0-.305-.022z",
    className: "prefix__cls-2",
    "data-name": "Path 2",
    transform: "translate(-412.491 -492.202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_3",
    d: "M440.872 713.649l7.684 4.818a.172.172 0 0 0 .24-.062l4.548-7.955a.172.172 0 0 0-.191-.251l-12.23 3.138a.172.172 0 0 0-.05.312z",
    className: "prefix__cls-3",
    "data-name": "Path 3",
    transform: "translate(-413.564 -666.326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_4",
    d: "M369.1 773.693l-3.56 8.756a.172.172 0 0 0 .213.228l11.54-3.806a.172.172 0 0 0 .036-.309l-7.979-4.952a.172.172 0 0 0-.25.082z",
    className: "prefix__cls-4",
    "data-name": "Path 4",
    transform: "translate(-342.945 -725.802)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_5",
    d: "M842.466 628.012l-20.023 10.824a.172.172 0 0 1-.251-.18l2.613-15.124a.172.172 0 0 1 .211-.138l17.41 4.3a.172.172 0 0 1 .041.318z",
    className: "prefix__cls-1",
    "data-name": "Path 5",
    transform: "translate(-771.403 -584.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6",
    d: "M686.089 625.1l-2.277 15.257a.172.172 0 0 1-.309.078l-7.67-10.18a.172.172 0 0 1 .059-.256l9.95-5.077a.172.172 0 0 1 .248.179z",
    className: "prefix__cls-2",
    "data-name": "Path 6",
    transform: "translate(-634.054 -586.307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_7",
    d: "M648.051 733.721l-8.986-1.219a.172.172 0 0 1-.146-.2l1.6-9.018a.172.172 0 0 1 .309-.07l7.385 10.236a.172.172 0 0 1-.162.272z",
    className: "prefix__cls-3",
    "data-name": "Path 7",
    transform: "translate(-599.451 -678.474)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_8",
    d: "M648.94 890.268l-2.871 9.006a.172.172 0 0 1-.309.039L639.331 889a.172.172 0 0 1 .17-.261l9.3 1.3a.171.171 0 0 1 .141.222z",
    className: "prefix__cls-4",
    "data-name": "Path 8",
    transform: "translate(-599.815 -833.844)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuraasaColoredSmall);
export default __webpack_public_path__ + "static/media/suraasa-colored-small.f802d2c7.svg";
export { ForwardRef as ReactComponent };